import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../../Context/InshData";
import { uri } from "../../../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../../../services/LoadingPage";
import ShiftsReport from "./ShiftsReport";
import ShiftsTypes from "./ShiftsTypes";
const defaultAutos = {
    Users: [],
};

export default function ShiftsReportCon() {

  const tb = {
    wait: true,
    UsersA: true,
    Shift:true,
    PumpsTrans:true,
    PermissionsTypeInv:true,
    PermShiftsUser:true,
    stor: { ...sto, branchi: sto.branchi},
    parms:{
      iempid: sto.empi,
      branch:sto.branchi,
      iuserid:sto.idi,
      db_name: sto?.db_name
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Users 

  )
    return <LoadingPage />;

    return (
      <ShiftsTypes
        {...{
          AutoOptions: AutoOptions?.Users ? AutoOptions : defaultAutos,
          isPurches:false,
        }}
      />
    );

}
